import { lazy } from "react"
import { ACL_READ, ACL_SUBJECT_CONFIGURATION } from "@configs/acl/constants"

const ConfigurationRoutes = [
    {
        path: "/configurations",
        component: lazy(() => import("@views/configuration/index.js")),
        exact: true,
        meta: {
            action: ACL_READ,
            resource: ACL_SUBJECT_CONFIGURATION
        }
    },
    {
        path: "/configurations/auto-verify",
        component: lazy(() => import("@views/configuration/verify/AutoVerify")),
        exact: true,
        meta: {
            action: ACL_READ,
            resource: ACL_SUBJECT_CONFIGURATION
        }
    },
    {
        path: "/configurations/banner",
        component: lazy(() => import("@views/configuration/banner/Banner")),
        exact: true,
        meta: {
            action: ACL_READ,
            resource: ACL_SUBJECT_CONFIGURATION
        }
    }
]

export default ConfigurationRoutes
